module.exports = __webpack_public_path__ + "static/media/coffin.7ca095c3.svg";